import api from "@/utils/axios";

const REFUND_API_URL = `/orders`;

export default {
  namespaced: true,
  state: {
    loading: false,
    error: null,
  },
  mutations: {
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    CLEAR_ERROR(state) {
      state.error = null;
    },
  },
  actions: {
    async addRefund({ commit }, { order_id, data }) {
      commit("SET_LOADING", true);
      commit("CLEAR_ERROR");
      try {
        const res = await api.post(
          `${REFUND_API_URL}/${order_id}/refunds/`,
          data
        );
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || "Failed to add refund"
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async deleteRefund({ commit }, refund_id) {
      commit("SET_LOADING", true);
      commit("CLEAR_ERROR");
      try {
        await api.delete(`${REFUND_API_URL}/refunds/${refund_id}/`);
        return true;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || "Failed to delete refund"
        );
        return false;
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
  getters: {
    refundLoading: (state) => state.loading,
    refundError: (state) => state.error,
  },
};
